<script setup>
import GridList from '../others/GridList.vue'
import { ref } from 'vue'
import SlideDetailView from '../others/SlideDetailView.vue'
import AccompaniementDetails from '../accompaniements/AccompaniementDetails.vue'
import AccompaniementEditor from '../accompaniements/AccompaniementEditor.vue'
import { cloneDeep } from 'lodash-es'
import ActionTrigger from '@/features/data/presentation/components/ActionTrigger.vue'
import { EVENTS } from '@/shared/constants/commons'
import Events from '@/events/events'
import Commons from '@/shared/utils/commons'

const cols = [
  {
    name: 'Nom',
    id: 'name',
    image(el) {
      return el.image
    },
    value(el) {
      return [el.name || '-', Commons.truncate(el.description || '-', 37)]
    },
  },
  {
    name: 'Montant par défaut',
    id: 'price',
    value(el) {
      return Commons.formatNumber(el.price || 0, { suffix: ' FCFA' })
    },
  },
  {
    name: '',
    id: 'action',
    icon: () => '/images/icons/eye.png',
    onClick(el) {
      detailData.value = cloneDeep(el)
    },
    value() {},
  },
]

const buttons = [
  {
    title: '&plus; Ajouter',
    onClick() {
      detailData.value = {}
      editAccompaniement.value = true
    },
  },
]

const detailData = ref(null)
const editAccompaniement = ref(false)
const saveAccompaniement = ref(false)

async function deleteAccompaniement(data) {
  const res = await window.customPrompt({
    title:
      "Voulez-vous vraiment supprimer l'accompagnement " +
      (data.name || data.title || '') +
      ' ? Vous ne pourrez plus la récupérer.',
    formFields: [],
    successText: 'Supprimer',
    cancelText: 'Retour',
  })

  if (!res.accepted) return
  saveAccompaniement.value.trigger({ id: data.id, action: 'delete' })
}

async function deactivateAccompaniement(data) {
  saveAccompaniement.value.trigger({ id: data.id, action: 'deactivate' })
}

async function activateAccompaniement(data) {
  saveAccompaniement.value.trigger({ id: data.id, action: 'activate' })
}
</script>

<template>
  <div class="p-5 h-full overflow-auto">
    <GridList

      :elClickHanler="(el)=>{
        detailData = el
      }"
      title="Accompagnements"
      dataKey="accompaniements"
      hasSearch
      :cols="cols"
      :buttons="buttons"
      :cardConfig="{
        imageField: 'image',
        titleField: 'name',
        statusField: 'activeStatus',
        descriptionField: 'description',
        priceField: 'price',
      }"
      :gridCols="{ sm: 1, md: 2, lg: 3, xl: 4 }"
    ></GridList>
  </div>

  <SlideDetailView :isVisible="!!detailData?.id" @hide="detailData = null">
    <div class="flex gap-4 absolute right-14 top-4">
      <button
        class="buttonComponent small border rounded-xl bg-red-500"
        @click="deleteAccompaniement(detailData)"
      >
        Supprimer
      </button>
      <button
        class="buttonComponent small border rounded-xl"
        @click="deactivateAccompaniement(detailData)"
        v-if="detailData.isActive"
      >
        Désactiver
      </button>
      <button
        v-else
        class="buttonComponent small border rounded-xl"
        @click="activateAccompaniement(detailData)"
      >
        Activer
      </button>
      <button
        class="buttonComponent bg-green-500 small border rounded-xl"
        @click="editAccompaniement = true"
      >
        Modifier
      </button>
    </div>
    <AccompaniementDetails
      v-if="detailData?.id"
      :accompaniementData="detailData"
    />
  </SlideDetailView>

  <SlideDetailView
    :isVisible="!!detailData && editAccompaniement"
    @hide="editAccompaniement = false"
  >
    <AccompaniementEditor
      v-if="detailData"
      :accompaniementData="detailData"
      @saved="editAccompaniement = false"
    />
  </SlideDetailView>

  <ActionTrigger
    dataKey="saveAccompaniement"
    ref="saveAccompaniement"
    @success="detailData = null"
    @failed="
      err => {
        Events.dispatch(EVENTS.TOAST_NOTIFICATION_REQUESTED, {
          title: 'Échec de suppression',
          body: `${err.result?.message || 'Erreur non détectée'}`,
        })
      }
    "
  />
</template>
